import { Button } from "antd";

const FormButton = ({
  id,
  name = "",
  label = "",
  rules = undefined,
  widthSize = "default", //large, small, default
  category = "default", //primary, dashes, text, link, default
  color = "default", //primary, danger, default, color value
  variant = "outlined", //solid, outlined, dashed, filled, text, link
  htmlType = "",
  ...rest
}: any) => {
  return (
    <Button type={category} color={color} variant={variant} size={widthSize} htmlType={htmlType} {...rest}>
      {label}
    </Button>
  );
};

export default FormButton;
